import React from 'react';
import PopularDestinations from '../components/PopularDestinations';
import TravelInspiration from '../components/TravelInspiration';

const Explore: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Explore Destinations</h1>
          <p className="page-subtitle">
            Discover amazing places around the world and get inspired for your next adventure
          </p>
        </div>
      </div>
      
      <PopularDestinations />
      <TravelInspiration />
      
      <section className="explore-more">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Plan Your Adventure</h2>
            <p className="section-subtitle">
              Ready to explore? Let our AI create the perfect itinerary for your dream destination
            </p>
          </div>
          <div className="explore-cta">
            <button className="cta-button-large">Start Planning Now</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Explore; 